import { Button, Input, Label } from '../ui'
import type { LatenessReportFilters } from '../../types/reports.types'

interface Department {
  id: string
  name: string
}

interface LatenessFiltersProps {
  filters: LatenessReportFilters
  onFiltersChange: (filters: Partial<LatenessReportFilters>) => void
  onGenerateReport: () => void
  departments?: Department[]
  isLoading?: boolean
}

export function LatenessFilters({
  filters,
  onFiltersChange,
  onGenerateReport,
  departments = [],
  isLoading = false,
}: LatenessFiltersProps) {
  const handleClear = () => {
    const today = new Date().toISOString().split('T')[0]
    onFiltersChange({
      date: today,
      departmentId: undefined,
    })
  }

  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-end gap-4">
        {/* Date picker */}
        <div className="space-y-2">
          <Label htmlFor="date">Дата</Label>
          <Input
            id="date"
            type="date"
            value={filters.date}
            onChange={(e) => onFiltersChange({ date: e.target.value })}
            className="w-[180px]"
          />
        </div>

        {/* Department select */}
        <div className="space-y-2">
          <Label htmlFor="department">Подразделение</Label>
          <select
            id="department"
            value={filters.departmentId || ''}
            onChange={(e) =>
              onFiltersChange({ departmentId: e.target.value || undefined })
            }
            className="h-10 w-[220px] rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
          >
            <option value="">Все подразделения</option>
            {departments.map((dept) => (
              <option key={dept.id} value={dept.id}>
                {dept.name}
              </option>
            ))}
          </select>
        </div>

        {/* Generate button */}
        <Button onClick={onGenerateReport} disabled={isLoading}>
          {isLoading ? 'Загрузка...' : 'Сформировать отчет'}
        </Button>
      </div>

      {/* Clear and Export buttons */}
      <div className="flex gap-2">
        <Button variant="outline" onClick={handleClear}>
          Очистить
        </Button>
        <Button variant="default" className="bg-green-600 hover:bg-green-700" disabled>
          <span className="mr-2">📊</span>
          Экспорт в Excel
        </Button>
      </div>
    </div>
  )
}
